var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import UiSecondaryButton from '../../../../ui/v1/controls/UiSecondaryButton.vue';
import UiButton from '../../../../ui/v1/controls/UiButton.vue';
var CookiePreferenceFooter = /** @class */ (function (_super) {
    __extends(CookiePreferenceFooter, _super);
    function CookiePreferenceFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CookiePreferenceFooter.prototype.created = function () {
        if (this.getPreferenceFromCookies() === 'true') {
            this.$emit('loadScripts');
        }
    };
    CookiePreferenceFooter.prototype.mounted = function () {
        if (this.getPreferenceFromCookies() === 'not_set') {
            this.$emit('showFooter', true);
        }
    };
    CookiePreferenceFooter.prototype.getPreferenceFromCookies = function () {
        var _a;
        return ((_a = document.cookie.match('(^|;)\\s*allow_analytics\\s*=\\s*([^;]+)')) === null || _a === void 0 ? void 0 : _a.pop()) || 'not_set';
    };
    CookiePreferenceFooter.prototype.setCookiePreference = function (bool) {
        // Store preference in cookie that expires in 30 days
        document.cookie = "allow_analytics=" + bool + "; max-age=2592000";
        if (bool === true) {
            this.$emit('loadScripts');
        }
        this.$emit('showFooter', false);
    };
    __decorate([
        Prop({ required: true }),
        __metadata("design:type", String)
    ], CookiePreferenceFooter.prototype, "policyUrl", void 0);
    CookiePreferenceFooter = __decorate([
        Component({
            components: { UiButton: UiButton, UiSecondaryButton: UiSecondaryButton },
        })
    ], CookiePreferenceFooter);
    return CookiePreferenceFooter;
}(Vue));
export default CookiePreferenceFooter;
